// Identity function so a class string sits where Biome's useSortedClasses looks — a bare string constant never gets sorted, this does.
export const tw = (classes: string) => classes;
